import { reactive } from 'vue'
import fallback from '@/translate'

const messages = reactive<Record<string, string>>({ ...fallback })

export function setLocaleMessages(lang: Record<string, string> | undefined) {
  if (!lang || typeof lang !== 'object') return
  for (const [key, value] of Object.entries(lang)) {
    // Пустая строка с бэка не должна затирать RU-фолбэк из translate.ts
    if (typeof value === 'string' && value.trim() !== '') {
      messages[key] = value
    }
  }
}

export function t(key: string, fallbackText = key): string {
  return messages[key] ?? fallbackText
}

export function useI18n() {
  return { t, messages }
}
